import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-031179c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-mass-discount" }
const _hoisted_2 = { class: "cart-mass-discount__heading" }
const _hoisted_3 = { class: "cart-mass-discount__items" }

import dictionary from "@/i18n/dictionary.json";
import TressCartQuantityOption from "@/components/TressCartQuantityOption.vue";
import { onMounted, PropType, ref, watch } from "vue";
import { IQuantityBreak } from "@/models/IQuantityBreak";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCartQuantitySelector',
  props: {
  quantityBreaks: {
    type: Array as PropType<Array<IQuantityBreak>>,
    required: true,
  },
  quantity: {
    type: Number,
    required: true,
  },
  unitOfMeasurement: {
    type: String,
    required: true,
  },
},
  emits: {
  click: (quantityBreak: IQuantityBreak) => true,
},
  setup(__props, { emit }) {

const props = __props;



const quantityBreaks = ref(props.quantityBreaks);
const onOptionClick = (quantityBreak: IQuantityBreak) => {
  quantityBreak.isChecked = true;
  quantityBreaks.value
    .filter((x) => x.value != quantityBreak.value)
    .map((x) => {
      x.isChecked = false;
      return x;
    });
  emit("click", quantityBreak);
};
watch(
  () => props.quantity,
  (currVal: number) => {
    _calcQuantityBreakChecked(currVal);
  }
);
const _calcQuantityBreakChecked = (currVal) => {
  const qtyBreak = quantityBreaks.value
    .filter((x) => x.qtyBreak <= currVal)
    .map((x) => {
      return { item: x, score: Math.abs(x.qtyBreak - currVal) };
    })
    .sort((x, y) => x.score - y.score)[0];
  if (qtyBreak) {
    qtyBreak.item.isChecked = true;
    quantityBreaks.value
      .filter((x) => x.qtyBreak != qtyBreak.item.qtyBreak)
      .map((x) => {
        x.isChecked = false;
        return x;
      });
  } else {
    quantityBreaks.value.map((x) => {
      x.isChecked = false;
      return x;
    });
  }
};
onMounted(() => {
  _calcQuantityBreakChecked(props.quantity);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(_unref(dictionary).common.massDiscount)), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quantityBreaks.value, (quantityBreak) => {
          return (_openBlock(), _createBlock(TressCartQuantityOption, {
            key: quantityBreak.qtyBreak,
            "is-checked": quantityBreak.isChecked,
            "quantity-break": quantityBreak,
            onClick: onOptionClick,
            unitOfMeasurement: __props.unitOfMeasurement
          }, null, 8, ["is-checked", "quantity-break", "unitOfMeasurement"]))
        }), 128))
      ])
    ])
  ]))
}
}

})